import { Close, CheckCircleOutline } from "@mui/icons-material";
import { Button, Box, Typography, Paper, TableContainer } from "@mui/material";
import { useContext } from "react";
import { ModuleContext } from "../../context/ModuleContext";
import { Office365GroupContext } from "../../context/Office365GroupContext";

const WSU_RED = "#A60F2D";

export const CreateGroupConfirm = () => {
  const { setModule } = useContext(ModuleContext);
  const { groupModule, setGroupModule } = useContext(Office365GroupContext);

  const handleClose = () => {
    setModule((prev) => ({ ...prev, isVisible: false }));
    setGroupModule((prev) => ({ ...prev, isOpen: false }));
  };

  return (
      <TableContainer
          component={Paper}
          elevation={2}
          sx={{ borderRadius: 2, overflow: "hidden" }}
      >
        {/* Success Banner */}
        <Box sx={{ backgroundColor: "#2e7d32", color: "white", px: 3, py: 2, display: "flex", alignItems: "center", gap: 1.5 }}>
          <CheckCircleOutline fontSize="small" />
          <Typography variant="subtitle2" fontWeight={700}>
            Group Created Successfully
          </Typography>
        </Box>

        {/* Message */}
        <Box sx={{ px: 3, pt: 3, pb: 1 }}>
          <Typography variant="overline" sx={{ color: WSU_RED, fontWeight: 700, letterSpacing: 1.5 }}>
            Confirmation
          </Typography>
        </Box>

        <Box sx={{ px: 3, py: 2 }}>
          <Typography variant="body2" color="text.secondary">
            Group <strong>{groupModule.id}</strong> has been created. Please allow up to 15 minutes for provisioning to complete.
          </Typography>
        </Box>

        {/* Close Button */}
        <Box sx={{ px: 3, pb: 4, display: "flex", justifyContent: "flex-end" }}>
          <Button
              variant="outlined"
              endIcon={<Close />}
              onClick={handleClose}
              sx={{
                borderColor: "#ccc",
                color: "#666",
                "&:hover": { borderColor: "#aaa", backgroundColor: "#f9f9f9" },
              }}
          >
            Close
          </Button>
        </Box>
      </TableContainer>
  );
};